import React from 'react';
import cx from 'classnames';

/**
 * @typedef {object} DatePickerArrowWrapperProps
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} handleLeftArrowClick
 * @property {boolean} [isLeftArrowDisabled]
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} handleRightArrowClick
 * @property {React.ReactNode} children
 */

/**
 * @param {DatePickerArrowWrapperProps} props
 */
const DatePickerArrowWrapper = props => {
  const { handleLeftArrowClick, handleRightArrowClick, isLeftArrowDisabled, children } = props;

  return (
    <div className='date-picker-with-arrows'>
      <button
        className={cx('arrow', { disabled: isLeftArrowDisabled })}
        onClick={handleLeftArrowClick}
        disabled={isLeftArrowDisabled}>
        &#9664;
      </button>
      {children}
      <button className='arrow' onClick={handleRightArrowClick}>
        &#9654;
      </button>
    </div>
  );
};

export default DatePickerArrowWrapper;
